import { motion } from "framer-motion";
import {Quote} from 'lucide-react';

const testimonials = [
{
  quote: "O que fez diferença foi ter professor real. Não sou eu sozinho na plataforma.",
  name: "Ana",
  age: "34 anos",
  role: "marketing digital",
  image: "https://images.pexels.com/photos/1181690/pexels-photo-1181690.jpeg?auto=compress&cs=tinysrgb&w=200",
  accent: "blue"
},
{
  quote: "Falei na primeira semana. Não precisei esperar 6 meses para abrir a boca.",
  name: "Roberto",
  age: "29 anos",
  role: "engenheiro",
  image: "https://images.pexels.com/photos/2182970/pexels-photo-2182970.jpeg?auto=compress&cs=tinysrgb&w=200",
  accent: "red"
},
{
  quote: "A Lucy me salvou às 23h antes de uma reunião importante. Responde na hora.",
  name: "Fernanda",
  age: "31 anos",
  role: "consultora",
  image: "https://images.pexels.com/photos/1065084/pexels-photo-1065084.jpeg?auto=compress&cs=tinysrgb&w=200",
  accent: "blue"
},
{
  quote: "Fiz o teste de nível antes e depois. Subi do básico ao intermediário em 5 meses.",
  name: "Lucas",
  age: "27 anos",
  role: "analista financeiro",
  image: "https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=200",
  accent: "red"
}];


export default function DetailedTestimonials() {
  return (
    <section className="bg-gray-50 md:py-20 pt-[40px] pb-[40px]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-serif text-3xl md:text-4xl font-bold text-blue-900 text-center mb-12">A estrutura que já transformou milhares de alunos


        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) =>
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className={`bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300 border-t-4 ${
            t.accent === "blue" ? "border-blue-600" : "border-red-600"}`
            }>

              <Quote className={`w-8 h-8 mb-3 ${t.accent === "blue" ? "text-blue-300" : "text-red-300"}`} />
              <p className="text-gray-800 text-lg font-medium mb-4 leading-relaxed italic">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3">
                <img
                src={t.image}
                alt={t.name}
                className={`w-12 h-12 rounded-full object-cover border-2 ${
                t.accent === "blue" ? "border-blue-900" : "border-red-600"}`
                } />

                <div>
                  <p className="font-bold text-blue-900">{t.name}, {t.age}</p>
                  <p className="text-gray-500 text-sm">{t.role}</p>
                </div>
              </div>
            </motion.div>
          )}
        </div>

        <div className="flex justify-center mt-10">
          <a
            href="#cta-final"
            onClick={(e) => { e.preventDefault(); document.getElementById('cta-final')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="cta-button inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold text-lg md:text-xl px-10 py-5 rounded-xl shadow-lg shadow-red-600/30 hover:shadow-red-600/50 transition-all duration-300 hover:scale-105 animate-pulse-glow cursor-pointer"
          >
            <span className="text-2xl">👉</span> Se eles conseguiram, eu também consigo
          </a>
        </div>
      </div>
    </section>);

}